module.exports = __webpack_public_path__ + "img/hr-tree-09-c-trunk.2e636c4d.png";